import countries from "../../Data/countries.json";

const get_country_by_name = (country_name) => {
  return countries.find(country => country.name === country_name)
}

const get_country_names = () => {
  return countries.map(country => country.name);
}

const get_country_calling_codes = () => {

  const filtered_countries = []
  countries.forEach(country => {
    if (country.callingCodes?.length > 0) {
      filtered_countries.push({
        country_name: country.name,
        calling_code: country?.callingCodes?.[0]
      })
    }
  });
  return filtered_countries;

}

const get_calling_codes_only = () => {

  const filtered_countries = new Set()
  countries.forEach(country => {
    if (country.callingCodes?.length > 0) {
      filtered_countries.add(+country?.callingCodes?.[0])
    }
  });
  return Array.from(filtered_countries);

}

export {
  get_country_by_name,
  get_country_names,
  get_country_calling_codes,
  get_calling_codes_only
}